import { useSystemEmailPreviewDisclosure } from "../../../hooks/admin/useSystemEmailPreviewDisclosure";
import { SystemEmailRegistryEntry } from "../../../services/admin/systemEmails.service";
import { SystemEmailPreviewDrawer } from "./SystemEmailPreviewDrawer";
import { SystemEmailRegistryContent } from "./SystemEmailRegistryContent";
import { SystemEmailRegistryEmptyState } from "./SystemEmailRegistryEmptyState";

interface Props {
  entries: SystemEmailRegistryEntry[];
  filtered: boolean;
}

export function SystemEmailRegistryTable({ entries, filtered }: Props) {
  const preview = useSystemEmailPreviewDisclosure();
  if (!entries.length)
    return <SystemEmailRegistryEmptyState filtered={filtered} />;
  return (
    <>
      <SystemEmailRegistryContent entries={entries} onPreview={preview.open} />
      <SystemEmailPreviewDrawer
        emailTypeId={preview.emailTypeId}
        onClose={preview.close}
        opened={preview.opened}
      />
    </>
  );
}
